import { useEffect, useState } from "react";
import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { ColumnMenuDefaultFilter } from "../Shared/Components/ColumnMenuFilter";
import { Link, useNavigate, useParams } from "react-router-dom";
import JobSubCategoryService from "../Shared/Services/JobSubCategoryService";
import SweetAlertService from "../../../services/SweetAlertService";
import { DeletePopupConfirmationMessage, } from "../Shared/Constants/AdminModuleConstants";
import JobCategoryService from "../Shared/Services/JobCategoryService";

export const JobSubCategoryList = () => {
    const { id } = useParams();
    let initialState = { dataState: { skip: 0, take: 20 }, result: { data: [], total: 0 } };

    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);
    const [jobCategoryName, setJobCategoryName] = useState("");

    useEffect(() => {
        getJobCategoryById();
        fetchData(dataState, id);
    }, []);

    const fetchData = (state: State, categoryId: any) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        JobSubCategoryService.getAllJobSubCategoriesByJobCategoryID(queryStr, categoryId)
            .then((response) => {
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }

    const getJobCategoryById = () => {
        JobCategoryService.getJobCategoryById(Number(id))
            .then((response) => {
                setJobCategoryName(response.data.name);
            })
    }

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState, id);
    };

    const navigate = useNavigate();

    const onDelete = (jobSubCategoryId: any) => {
        SweetAlertService.confirm('Delete', DeletePopupConfirmationMessage).then((result) => {
            if (result.isConfirmed) {
                JobSubCategoryService.deleteJobSubCategoryById(jobSubCategoryId).then((res) => {
                    if (res) {
                        fetchData(dataState, id);
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        });
    }

    const renderActionCell = (props: any) => {
        return (
            <td>
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/editjobsubcategory/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-edit k-icon-color"></span>
                </a> &nbsp;
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/viewjobsubcategory/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-information k-icon-color"></span>
                </a> &nbsp;
                <a className="btn btn-primary btn-sm" onClick={() => onDelete(props.dataItem.id)}>
                    <span className="k-icon k-i-delete k-icon-color"></span>
                </a>
            </td>
        );
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4><Link className="custom-nav-link" to="/jobcategory">{jobCategoryName} sub categories</Link>
                    <button
                        title="Create Job sub category"
                        className="btn btn-primary pull-right"
                        onClick={() => navigate(`/addjobsubcategory/${id}`)}>
                        Create job subcategory
                    </button>
                </h4>
            </div>
            <div className="card-body card-body-custom">
                <Grid
                    sortable={true}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 10, 15, 20],
                    }}
                    {...dataState}
                    data={result}
                    onDataStateChange={dataStateChange}>
                    <GridColumn field="name" title="Name" columnMenu={ColumnMenuDefaultFilter} width="990px"/>
                    {/*<GridColumn field="isDefaultInWorkActivity" filter="boolean" title="Default in WorkActivity" columnMenu={ColumnMenuDefaultFilter} width="500px" />*/}
                    <GridColumn title="Action" cell={renderActionCell} width="250px" />
                </Grid>
            </div>
        </div>
    )
}